var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerx sidebar"},[_c('vs-sidebar',{staticClass:"sidebarx",attrs:{"position-right":"","parent":"body","default-index":"1"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('div',{staticClass:"content",class:this.className,domProps:{"innerHTML":_vm._s(this.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }